var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip-group',_vm._l((_vm.statusToDisplay),function(s){return _c('v-chip',{key:s.value,attrs:{"small":"","dark":_vm.dark,"color":_vm.color ? _vm.color : s.color}},[_vm._v(" "+_vm._s(s.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }